import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhSvgImagesComponent } from './components/fh-svg-images.component';
import { FhSvgSuccessComponent } from './components/templates/success/fh-svg-success.component';
import { FhSvgAddUserComponent } from './components/templates/add-user/fh-svg-add-user.component';
import { FhSvgCanceledComponent } from './components/templates/canceled/fh-svg-canceled.component';
import { FhSvgCompletedComponent } from './components/templates/completed/fh-svg-completed.component';
import { FhSvgDeclinedComponent } from './components/templates/declined/fh-svg-declined.component';
import { FhSvgPendingComponent } from './components/templates/pending/fh-svg-pending.component';
import { FhSvgWarningComponent } from './components/templates/warning/fh-svg-warning.component';
import { FhSvgRegisterComponent } from './components/templates/register/fh-svg-register.component';
import { FhSvgApplicationComponent } from './components/templates/application/fh-svg-application.component';
import { FhSvgWavesComponent } from './components/templates/waves/fh-svg-waves.component';
import { FhSvgPasswordComponent } from './components/templates/password/fh-svg-password.component';
import { FhSvgApproveConsultComponent } from './components/templates/approve-consult/fh-svg-approve-consult.component';
import { FhSvgAppointmentComponent } from './components/templates/appointment/fh-svg-appointment.component';
import { FhSvgAuthorizationComponent } from './components/templates/authorization/fh-svg-authorization.component';
import { FhSvgRefundsComponent } from './components/templates/refunds/fh-svg-refunds.component';
import { FhSvgMedicineComponent } from './components/templates/medicine/fh-svg-medicine.component';
import { FhSvgSimulatorComponent } from './components/templates/simulator/fh-svg-simulator.component';
import { FhSvgAgreementComponent } from './components/templates/agreement/fh-svg-agreement.component';
import { FhSvgHandAgreementComponent } from './components/templates/hand-agreement/fh-svg-hand-agreement.component';
import { FhSvgNotFoundComponent } from './components/templates/not-found/fh-svg-not-found.component';
import { FhSvgLoadingComponent } from './components/templates/loading/fh-svg-loading.component';
import { FhSvgLostInternetComponent } from './components/templates/lost-internet/fh-svg-lost-internet.component';
import { FhSvgAdhesionComponent } from './components/templates/adhesion/fh-svg-adhesion.component';
import { FhSvgFilesUploadComponent } from './components/templates/files-upload/fh-svg-files-upload.component';

@NgModule({
  imports: [CommonModule, FhSvgAgreementComponent],
  declarations: [
    FhSvgImagesComponent,
    FhSvgSuccessComponent,
    FhSvgAddUserComponent,
    FhSvgCanceledComponent,
    FhSvgCompletedComponent,
    FhSvgDeclinedComponent,
    FhSvgPendingComponent,
    FhSvgWarningComponent,
    FhSvgRegisterComponent,
    FhSvgApplicationComponent,
    FhSvgPasswordComponent,
    FhSvgWavesComponent,
    FhSvgApproveConsultComponent,
    FhSvgAppointmentComponent,
    FhSvgAuthorizationComponent,
    FhSvgRefundsComponent,
    FhSvgMedicineComponent,
    FhSvgSimulatorComponent,
    FhSvgHandAgreementComponent,
    FhSvgNotFoundComponent,
    FhSvgLoadingComponent,
    FhSvgLostInternetComponent,
    FhSvgLostInternetComponent,
    FhSvgAdhesionComponent,
    FhSvgFilesUploadComponent
  ],
  exports: [FhSvgImagesComponent]
})
export class FhSvgImagesModule {}
